import type { GlucoseAverageReadingInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import {
  useDisplayGlucoseValue,
  useReadableGlucoseUnit,
} from "src/hooks"

export function GlucoseAverageReading(props: TileProps<GlucoseAverageReadingInsight>) {
  const {
    insightKey,
    range,
  } = props

  const displayGlucoseValue = useDisplayGlucoseValue()
  const glucoseUnit = useReadableGlucoseUnit()

  const { glucoseCalculations } = useCalculationsContext()
  const { average } = glucoseCalculations[range] || {}

  const value = (isNaN(average) || average === undefined)
    ? "--"
    : displayGlucoseValue(average)

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {value}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {glucoseUnit}
      </TileUnit>
    </>
  )
}
